import type { CrosswordAction } from './reducer';
import type { CrosswordDoc } from './doc';

// Estado de UI LOCAL do módulo (não entra no doc, não é desfazível). Fica no
// MetaContext do provider.
//
//  - selectedDead: a casa de dica em foco (o painel edita as respostas dela).
//  - focusRef: a resposta recém-criada (só para dar autoFocus no campo dela).
//  - nextRef: contador para refs de palavras NOVAS. Usa prefixo "n" para nunca
//    colidir com os refs "w{id}" derivados de um jogo carregado.

export interface CrosswordUi {
  selectedDead: { x: number; y: number } | null;
  focusRef: string | null;
  nextRef: number;
}

export function initialCrosswordUi(doc: CrosswordDoc): CrosswordUi {
  // Começa o contador acima de qualquer "n{n}" que já exista (defensivo; um jogo
  // carregado só tem refs "w{id}", mas mantém o invariante se algo mudar).
  const maxN = doc.words
    .map((w) => (/^n(\d+)$/.exec(w.ref) ? Number(/^n(\d+)$/.exec(w.ref)![1]) : 0))
    .reduce((a, b) => Math.max(a, b), 0);
  return { selectedDead: null, focusRef: null, nextRef: maxN + 1 };
}

export function newRef(ui: CrosswordUi): string {
  return `n${ui.nextRef}`;
}

/**
 * Chave de coalescing do undo: ações contínuas com a mesma chave viram uma entrada.
 * Digitar uma palavra (ou uma dica) inteira = um undo; colocar casa/pendurar/mover
 * são marcos próprios (null).
 */
export function coalesceKeyFor(action: CrosswordAction): string | null {
  switch (action.type) {
    case 'TYPE_LETTER':
      return `type:${action.ref}`;
    case 'SET_WORD':
      return `word:${action.ref}`;
    case 'BACKSPACE':
      return `back:${action.ref}`;
    case 'SET_CLUE':
      return `clue:${action.ref}`;
    case 'SET_META':
      return 'meta';
    default:
      return null;
  }
}
